import { render, staticRenderFns } from "./xx.vue?vue&type=template&id=6ff818a0&scoped=true&"
import script from "./xx.vue?vue&type=script&lang=js&"
export * from "./xx.vue?vue&type=script&lang=js&"
import style0 from "./xx.vue?vue&type=style&index=0&id=6ff818a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff818a0",
  null
  
)

export default component.exports